/* Lightweight wishlist — localStorage backed.
   - Header heart shows a count badge ([data-wishlist-count]).
   - Any [data-wishlist-toggle][data-wishlist-id] button adds/removes an item
     and reflects its active state (.is-active). */
(function () {
  'use strict';
  var KEY = 'cp_wishlist';

  function get() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY)) || [];
      return list.map(function (item) { return typeof item === 'object' ? item : { id: item }; });
    } catch (e) { return []; }
  }
  function save(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function updateCount() {
    var n = get().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  function markActive() {
    var list = get();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist-id');
      btn.classList.toggle('is-active', list.some(function (item) { return String(item.id) === String(id); }));
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-wishlist-id');
    if (!id) return;
    var list = get();
    var i = list.findIndex(function (item) { return String(item.id) === String(id); });
    if (i >= 0) { list.splice(i, 1); btn.classList.remove('is-active'); }
    else {
      list.push({
        id: id,
        url: btn.getAttribute('data-wishlist-url') || '#',
        title: btn.getAttribute('data-wishlist-title') || 'Product',
        image: btn.getAttribute('data-wishlist-image') || '',
        price: btn.getAttribute('data-wishlist-price') || ''
      });
      btn.classList.add('is-active');
    }
    save(list);
    updateCount();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list } }));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    btn.click();
  });

  document.addEventListener('wishlist:change', function () {
    updateCount();
    markActive();
  });

  updateCount();
  markActive();
})();
